import { render } from "./agentsAppoinments.vue?vue&type=template&id=2833b42e&scoped=true"
import script from "./agentsAppoinments.vue?vue&type=script&lang=js"
export * from "./agentsAppoinments.vue?vue&type=script&lang=js"

import "./agentsAppoinments.vue?vue&type=style&index=0&id=2833b42e&scoped=true&lang=css"
import "./agentsAppoinments.vue?vue&type=style&index=1&id=2833b42e&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2833b42e"]])

export default __exports__